import { functions } from "../firebase.ts";
import { httpsCallable } from "firebase/functions";

export class Functions {
    async removeBackground(photoURL?: string): Promise<string> {
        try {
            const send = httpsCallable<{ photoURL?: string }>(
                functions,
                "removeBackground"
            );
            const result = await send({ photoURL });
            return result.data as string; // image url
        } catch (error) {
            console.error(error);
            return "error";
        }
    }

    // push: 3
    async follow(address: string): Promise<string> {
        try {
            const send = httpsCallable<{
                address: string;
            }>(functions, "follow");
            const result = await send({
                address
            });
            return result.data as string; // "success"
        } catch (error) {
            console.error(error);
            return "error";
        }
    }

    // push: b-token
    async push(thank: string): Promise<string> {
        try {
            const send = httpsCallable<{
                thank: string;
            }>(functions, "push");
            const result = await send({
                thank
            });
            return result.data as string; // "success"
        } catch (error) {
            console.error(error);
            return "error";
        }
    }

    // push: b-thank
    async notify(thank: string): Promise<string> {
        try {
            const send = httpsCallable<{
                thank: string;
            }>(functions, "notify");
            const result = await send({
                thank
            });
            return result.data as string; // "success"
        } catch (error) {
            console.error(error);
            return "error";
        }
    }

    // push: admin
    async admin(title: string, body: string): Promise<string> {
        try {
            const send = httpsCallable<{
                title: string;
                body: string;
            }>(functions, "admin");
            const result = await send({
                title,
                body
            });
            return result.data as string; // "success"
        } catch (error) {
            console.error(error);
            return "error";
        }
    }

    // email: b-chest
    async broadcast(
        chest: any,
        blob: Blob | null,
        addresses: string[]
    ): Promise<string> {
        try {
            const send = httpsCallable<{
                chest: any;
                dataURL: string | null;
                addresses: string[];
            }>(functions, "sendEmail");
            const result = await send({
                chest,
                dataURL: blob ? await this.blobToDataURL(blob) : null,
                addresses
            });
            return result.data as string; // "success"
        } catch (error) {
            console.error(error);
            return "error";
        }
    }

    private blobToDataURL(blob: Blob): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onloadend = () => {
                const result = reader.result;
                if (typeof result === "string") {
                    resolve(result); // e.g. "data:image/gif;base64,AAA…"
                } else {
                    reject(new Error("Unexpected result type"));
                }
            };

            reader.onerror = () => reject(reader.error);
            reader.readAsDataURL(blob);
        });
    }
}
